import type { Partner } from 'shared/types'
import { client } from '../clients'

const getMany = () => client.get<Partner[]>('/partners/all')

export const partners = {
  getMany
}
